import { API_URL } from "config";
import Http from "util/https";
import Notify from "config/notify";
import { OrderCheck, OrderNumberStatus } from "../types";
import { convertUTCToDate, removeEmptyValues } from "../utils/common";

type Arg = {
  orderNumber: string;
  orderDate: string;
  orderNumberStatus?: OrderNumberStatus
  expectedShippingDate?: string;
}

/**
 * 注文ステータスを変更するAPI
 * @param args 引数
 */
export default async function updateOrderHistoryStatusApi(args: Arg) {
  console.log("updateOrderHistoryStatus:", args);

  const params = removeEmptyValues({
    // operation: 0,
    order_no: args.orderNumber,
    order_status: args.orderNumberStatus,
    order_date: convertUTCToDate(args.orderDate),
    scheduled_date: args.expectedShippingDate,
  }, [], true);

  const http = Http.default.alterAuth({ useToken: true });
  const url = `${API_URL}/order/product/change/status`;
  const res = await http.post<null>(url, params);
  // await new Promise<void>((resolve) => {setTimeout(resolve, 1500)});

  // const res = {status: 200};
  // if (res.status === 200) {
  //   Notify.setNotification({
  //     show: true,
  //     title: "更新が完了しました",
  //     confirmLabel: "OK",
  //     actionsPosition: "end",
  //   });
  // }
}
